////////////   项目依赖引入   //////////////
// vue框架
import Vue from 'vue';
// vue主页面
import App from './App.vue';
// vue路由
import router from './router';
// vuex
import store from './store';
// 公共Header栏
import Header from './components/Header';
// vue组件库vant的样式文件
import 'vant/lib/index.css';
// vue组件库vant的基本依赖文件
import vant from "vant";
// 请求工具文件
import post from "@/utils/request"
// 多语言切换
// import i18n from '@/plugin/lang/i18n'
// 正在校验文件
import common from './utils/common'
// 基础工具文件
import funcUtil from './utils/funcUtil/base'
// 移动端适配组件（px转rem必须组件之一）
import 'amfe-flexible'
// 剪切板组件，可以使用$copyText(text)方法复制文字
import VueClipboard from 'vue-clipboard2'
// vue公共指令文件
import "@/utils/command";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 页面预处理
import './utils/permission.js'
////////////   项目常用工具设置   //////////////
// 请求
Vue.prototype.$post = post;
// 校验
Vue.prototype.$ver = common
// 常用方法
Vue.prototype.$func = funcUtil;
// 是否开启vue警告提示，建议开发模式下开启，生产模式下关闭
Vue.config.productionTip = process.env.VUE_APP_RUN_DEV ? true : false;
// 头部
Vue.component('Header', Header);
// 引入的组件，vant VueClipboard
Vue.use(vant).use(VueClipboard);

// 定时方法，使用异步封装，方便使用（好像没啥用）
Vue.prototype.$sleep = time => {
  return new Promise(resolve => {
    window.setTimeout(() => {
      resolve()
    }, time)
  })
}


// import { Lazyload } from 'vant';

// Vue.use(Lazyload);

// // 注册时可以配置额外的选项
// Vue.use(Lazyload, {
//   lazyComponent: true,
// });
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad,{
    error:require('./assets/home/logo.png'),
    loading:require('./assets/home/logo.png')
})
////////////   创建vue对象   //////////////

new Vue({
  router,
  store,
  // i18n,
  render: h => h(App)
}).$mount('#app')
